import { render, staticRenderFns } from "./FormAddBaby.vue?vue&type=template&id=31af0264"
import script from "./FormAddBaby.vue?vue&type=script&lang=js"
export * from "./FormAddBaby.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports